import SnapshotTimeline from "components/controls/SnapshotTimeline";
import BlueRelationshipContext from "../BlueRelationshipContext";
import { useSelector } from "react-redux";
import { RootState } from "app/store";

const Timeline = () => {

    const state = useSelector((state: RootState) => state);

    return <BlueRelationshipContext>
        <SnapshotTimeline snapshot={state.data.snapshot} />
    </BlueRelationshipContext>;
}

export default Timeline;